import styled from 'styled-components';
import { mediaQuery } from 'modules/utils';
import { Flex } from 'modules/ui/flex';

export const FormButtonContainer = styled(Flex)<{
  maxWidth?: string;
  centered?: boolean;
  rightAligned?: boolean;
}>`
  width: 100%;

  justify-content: ${(props) => {
    if (props.centered) return 'center';
    if (props.rightAligned) return 'flex-end';
    return 'space-between';
  }};

  margin-top: 2rem;
  flex-direction: column;
  gap: 1rem;
  max-width: 100%;

  ${mediaQuery('md')} {
    flex-direction: row;
    gap: 2.625rem;
    ${(props) => (props.maxWidth ? `max-width: ${props.maxWidth};` : '')}
  }

  button {
    flex: 1;
    width: 100%;

    &:first-child {
      order: 1;
    }

    ${mediaQuery('md')} {
      width: auto;
      flex: 0.5;

      &:first-child {
        order: 0;
      }
    }
  }
`;
